<div class="AmBagsTable">
  <div class="AmBagsTable-content">
    <!-- table header -->
    <div class="AmBagsTable-header">
      <div class="th">
        {{ "bagsSelectionCarryon.table.headers.passenger" | translate }}
      </div>
      <div class="th">
        {{ "bagsSelectionCarryon.table.headers.detail" | translate }}
      </div>
      <div class="th">
        {{ "bagsSelectionCarryon.table.headers.price" | translate }}
      </div>
      <div class="th">
        <span>{{ "bagsSelectionCarryon.table.headers.bagsAddExtra" | translate }}</span>
        <span class="tag"> {{ "bagsSelectionCarryon.table.headers.news" | translate }}</span>
      </div>
    </div>
    <!-- table body -->
    <app-am-scroll  [height]="270">
    <div class="AmBagsTable-body">
      <div *ngFor="let item of passengers" class="tr">
        <div class="td">
          <am-bags-passenger class="w-100" [passenger]="item"></am-bags-passenger>
        </div>
        <div class="td">
          <am-bag-detail-carryon
          [bagWeight]="item.bagCarryon.typeBagWeight"
          [count]="1"
          ></am-bag-detail-carryon>
        </div>
        <div class="td">
          <am-bag-price-carryon
          [currencyCode]="item.getCurrencyCodeBagsToPayCarryon"
          [statusBag]="item.getStatusBagColumnCarryon"
          [totalAmount]="item.getTotalAmountBagColumnCarryon">
        </am-bag-price-carryon>
        </div>
        <div class="td">
          <am-bag-add-carryon
          [statusBag]="item.getStatusBagColumnCarryon"
          (onChangeExtraWeight)="handleChangeExtraWeightBags($event,item)"
          ></am-bag-add-carryon>
        </div>
      </div>
    </div>
    </app-am-scroll>
  </div>
  <!-- table footer -->
  <div class="AmBagsTable-footer">
    <div class="tf">
      <div class="container-info-footer">
        <img
          src="./assets//images/bags/icon-bag-footer-carryon.svg"
          alt="footer-bags"
        />
        <span class="title-footer">{{ "bagsSelectionCarryon.table.footer.passenger" | translate }}</span>
      </div>
    </div>
    <div class="tf"></div>
    <div class="tf status-global" [ngSwitch]="statusGlobalBags">
      <span *ngSwitchCase="StatusBag.NONE">
        {{'bagsSelectionCarryon.bag-status.none' | translate}}
      </span>
      <span *ngSwitchCase="StatusBag.INCLUDE">
        {{'bagsSelectionCarryon.bag-status.include' | translate}}
      </span>
      <span class="d-flex gap-1" *ngSwitchCase="StatusBag.PAID">
        <img src="./assets/images/bags/icon-bag-check.svg" alt="">
        {{'bagsSelectionCarryon.bag-status.paid' | translate}}
      </span>
      <div *ngSwitchCase="StatusBag.TO_PAY">
        <strong>{{totalAmountBags | amCurrency:'':'symbol':'0.0'}} </strong>
        <span>{{currencyCodeBags}}</span>
      </div>
    </div>
    <div class="tf"></div>
  </div>
</div>
